import { Autocomplete, TextField } from '@mui/material';
import customAxios from '../../../utils/customAxios';
import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import "../../../scss/Components/_modal.scss"
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { GlobalVariables } from '../../../globalVar';
import { getToast } from '../../../utils/toastConfig';

function ModalQ(props) {
    const {
        qModalCreateString,
        qModalCreateQNameString,
        qModalCreateQDescString,
        qModalCreateQVTypeString,
        saveString,
    } = useTranslationHook();

    const [visitTypes, setVisitTypes] = useState([]);

    useEffect(() => {
        customAxios.get(`${GlobalVariables.getURL()}listVisitTypes?unique=true`, {
            headers: {
                'Authorization': 'bearer ' + localStorage.getItem('token')
            }
        })
            .then((response) => {
                setVisitTypes(response.data);
            })

            .catch(error => console.log(error));
    }, []);

    const [newOption, setNewOption] = useState({ name: '', description: '' })
    const [selectedVisitTypes, setSelectedVisitTypes] = useState([]);

    function createQ(event) {
        event.preventDefault();
        customAxios.post(`${GlobalVariables.getURL()}createQuestionary`, {
            name: newOption.name,
            visit_types_selected: selectedVisitTypes,
            description: newOption.description
        }, {
            headers: {
                'Authorization': 'bearer ' + localStorage.getItem('token')
            }
        })
            .then((response) => {
                hide();
            }, (error) => {
                console.log(error);
                getToast({ status: 'error', title: 'Error al crear cuestionario. Vuelve a intentarlo.' });
            });
    }


    function hide() {
        props.onHide();
        getToast({ status: 'success', title: 'Cuestionario creado exitosamente en la base de datos.' });
        props.getQuestionnaires();
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {qModalCreateString}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form id='add-q-form' onSubmit={createQ}>
                    <div className="row">
                        <div className="col-md-12">
                            <TextField
                                sx={{ width: "100%" }}
                                label={qModalCreateQNameString}
                                type="text"
                                onChange={(e) => setNewOption({ ...newOption, name: e.target.value })}
                                required
                            />
                        </div>
                    </div>

                    <br />

                    <div className="row">
                        <div className="col-md-12">
                            <Autocomplete
                                disablePortal
                                options={visitTypes}
                                sx={{ width: "100%" }}
                                getOptionLabel={(visitTypes) => visitTypes.vt_name}
                                getOptionSelected={(visitTypes, value) => visitTypes.id === value.id}
                                renderInput={(params) => (
                                    <TextField {...params} label={qModalCreateQVTypeString}
                                        inputProps={{
                                            ...params.inputProps,
                                        }}
                                        required={selectedVisitTypes.length === 0}
                                    />
                                )}
                                onChange={(event, newValue) => {
                                    setSelectedVisitTypes(newValue);
                                }}
                            />
                        </div>
                    </div>

                    <br />

                    <div className="row">
                        <div className="col-md-12">
                            <TextField
                                multiline
                                sx={{ width: "100%" }}
                                label={qModalCreateQDescString}
                                rows={4}
                                type="text"
                                onChange={(e) => setNewOption({ ...newOption, description: e.target.value })}
                                required
                            />
                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <button form='add-q-form' type='submit' className='save-modal-button'>{saveString}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalQ;